import { createContext, useContext, useState } from "react";

const DICT = {
  es: {
    nav_home: "Inicio", nav_operator: "Operador Digital", nav_ecosystem: "Ecosistema",
    nav_legal: "Área Legal", nav_contact: "Contacto", nav_intranet: "Intranet",
    footer_rights: "Todos los derechos reservados.",
    footer_legal_title: "Marco Legal Corporativo",
    cookie_title: "Uso de cookies",
    cookie_text: "Utilizamos cookies propias necesarias para el funcionamiento del sitio y, solo con tu consentimiento, cookies de analítica y marketing. Consulta la",
    cookie_policy: "Política de Cookies",
    cookie_accept_all: "Aceptar todo", cookie_reject: "Rechazar", cookie_configure: "Configurar", cookie_save: "Guardar selección",
    cookie_necessary: "Necesarias", cookie_necessary_desc: "Imprescindibles para el funcionamiento y la seguridad del sitio.",
    cookie_analytics: "Analíticas", cookie_analytics_desc: "Nos ayudan a entender el uso del sitio de forma agregada.",
    cookie_marketing: "Marketing", cookie_marketing_desc: "Personalización y comunicaciones comerciales.",
    cookie_always_on: "Siempre activas",
    footer_cookie_prefs: "Preferencias de cookies",
    footer_system_title: "Acceso Corporativo",
    hero_default_cta: "Explorar",
    eco_title: "Ecosistema de Marcas",
    eco_sub: "Plataformas y marcas operadas por el núcleo digital corporativo.",
    tech_title: "Núcleo Tecnológico",
    tech_sub: "Capacidades centralizadas al servicio de todo el grupo.",
    pillar_tech: "Tecnología", pillar_auto: "Automatización", pillar_ai: "Inteligencia Artificial", pillar_infra: "Infraestructura",
    pillar_tech_d: "Plataformas digitales, desarrollo y arquitectura de sistemas corporativos.",
    pillar_auto_d: "Procesos automatizados que reducen trabajo, clics y errores.",
    pillar_ai_d: "IA aplicada a operaciones, análisis y gobierno corporativo.",
    pillar_infra_d: "Infraestructuras digitales seguras, escalables y monitorizadas.",
    legal_teaser_title: "Área Legal Corporativa",
    legal_teaser_sub: "Repositorio legal maestro: fuente única de verdad del ecosistema.",
    legal_teaser_cta: "Acceder al Área Legal",
    intranet_teaser_title: "Centro de Operaciones",
    intranet_teaser_sub: "Acceso privado a comunicados, documentación y recursos corporativos.",
    intranet_teaser_cta: "Acceso Intranet",
    status_activa: "Operativa", status_desarrollo: "En desarrollo", status_inactiva: "Inactiva",
    contact_title: "Contacto", contact_name: "Nombre", contact_email: "Email",
    contact_subject: "Asunto", contact_message: "Mensaje", contact_send: "Enviar",
    contact_ok: "Mensaje enviado correctamente.",
    login_title: "Acceso Corporativo", login_email: "Email", login_password: "Contraseña", login_btn: "Entrar",
    legal_version: "Versión", legal_hash: "Hash documental", legal_published: "Publicado",
    legal_updated: "Actualizado", legal_author: "Autor",
    legal_copyright: "© Natur Commodities. Contenido protegido. Prohibida su reproducción sin autorización.",
    legal_select: "Selecciona un documento del menú legal.",
    intranet_announcements: "Comunicados", intranet_links: "Enlaces rápidos", intranet_docs: "Documentación",
    matriz_access: "Panel MATRIZ", logout: "Salir",
    links_title: "Enlaces Corporativos",
    operator_h1: "Operador Digital Corporativo",
    operator_sub: "Natur Commodities centraliza tecnología, automatización, inteligencia artificial, infraestructuras digitales, documentación corporativa, plataformas, marcas y gobierno corporativo.",
    stat_brands: "Marcas operadas", stat_ops: "Operaciones continuas", stat_central: "Gestión centralizada", stat_platforms: "Plataformas digitales",
    why_overline: "Por qué Natur Commodities",
    why_title: "Tecnología centralizada al servicio de todo el grupo",
    why_sub: "Un único operador digital que elimina duplicidades, reduce costes y acelera cada marca del ecosistema.",
    why_1: "Infraestructura compartida y segura", why_2: "Automatización de procesos corporativos",
    why_3: "IA aplicada a la operación diaria", why_4: "Repositorio legal como fuente única de verdad",
    why_5: "Gobierno documental y trazabilidad", why_6: "Soporte continuo para todas las marcas",
    why_cta: "Conocer al operador",
    cta_title: "Centralizamos la tecnología. Multiplicamos el beneficio del ecosistema.",
    cta_sub: "Hablemos de cómo el operador digital puede impulsar tu área o tu marca.",
    legal_chip_versions: "Versiones", legal_chip_snapshots: "Snapshots", legal_chip_hash: "Hash SHA-256", legal_chip_history: "Historial",
    cta_btn: "Contactar ahora",
  },
  en: {
    nav_home: "Home", nav_operator: "Digital Operator", nav_ecosystem: "Ecosystem",
    nav_legal: "Legal Area", nav_contact: "Contact", nav_intranet: "Intranet",
    footer_rights: "All rights reserved.",
    footer_legal_title: "Corporate Legal Framework",
    cookie_title: "Cookie usage",
    cookie_text: "We use first-party cookies necessary for the site to work and, only with your consent, analytics and marketing cookies. See the",
    cookie_policy: "Cookie Policy",
    cookie_accept_all: "Accept all", cookie_reject: "Reject", cookie_configure: "Configure", cookie_save: "Save selection",
    cookie_necessary: "Necessary", cookie_necessary_desc: "Essential for the operation and security of the site.",
    cookie_analytics: "Analytics", cookie_analytics_desc: "Help us understand site usage in aggregate.",
    cookie_marketing: "Marketing", cookie_marketing_desc: "Personalization and commercial communications.",
    cookie_always_on: "Always on",
    footer_cookie_prefs: "Cookie preferences",
    footer_system_title: "Corporate Access",
    hero_default_cta: "Explore",
    eco_title: "Brand Ecosystem",
    eco_sub: "Platforms and brands operated by the corporate digital core.",
    tech_title: "Technology Core",
    tech_sub: "Centralized capabilities serving the entire group.",
    pillar_tech: "Technology", pillar_auto: "Automation", pillar_ai: "Artificial Intelligence", pillar_infra: "Infrastructure",
    pillar_tech_d: "Digital platforms, development and corporate systems architecture.",
    pillar_auto_d: "Automated processes that reduce work, clicks and errors.",
    pillar_ai_d: "AI applied to operations, analytics and corporate governance.",
    pillar_infra_d: "Secure, scalable and monitored digital infrastructure.",
    legal_teaser_title: "Corporate Legal Area",
    legal_teaser_sub: "Master legal repository: single source of truth for the ecosystem.",
    legal_teaser_cta: "Enter Legal Area",
    intranet_teaser_title: "Operations Center",
    intranet_teaser_sub: "Private access to announcements, documentation and corporate resources.",
    intranet_teaser_cta: "Intranet Access",
    status_activa: "Operational", status_desarrollo: "In development", status_inactiva: "Inactive",
    contact_title: "Contact", contact_name: "Name", contact_email: "Email",
    contact_subject: "Subject", contact_message: "Message", contact_send: "Send",
    contact_ok: "Message sent successfully.",
    login_title: "Corporate Access", login_email: "Email", login_password: "Password", login_btn: "Sign in",
    legal_version: "Version", legal_hash: "Document hash", legal_published: "Published",
    legal_updated: "Updated", legal_author: "Author",
    legal_copyright: "© Natur Commodities. Protected content. Reproduction without authorization is prohibited.",
    legal_select: "Select a document from the legal menu.",
    intranet_announcements: "Announcements", intranet_links: "Quick links", intranet_docs: "Documentation",
    matriz_access: "MATRIZ Panel", logout: "Sign out",
    links_title: "Corporate Links",
    operator_h1: "Corporate Digital Operator",
    operator_sub: "Natur Commodities centralizes technology, automation, artificial intelligence, digital infrastructure, corporate documentation, platforms, brands and corporate governance.",
    stat_brands: "Brands operated", stat_ops: "Continuous operations", stat_central: "Centralized management", stat_platforms: "Digital platforms",
    why_overline: "Why Natur Commodities",
    why_title: "Centralized technology serving the entire group",
    why_sub: "A single digital operator that removes duplication, cuts costs and accelerates every brand in the ecosystem.",
    why_1: "Shared, secure infrastructure", why_2: "Corporate process automation",
    why_3: "AI applied to daily operations", why_4: "Legal repository as single source of truth",
    why_5: "Document governance and traceability", why_6: "Continuous support for all brands",
    why_cta: "Meet the operator",
    cta_title: "We centralize technology. We multiply the ecosystem's benefit.",
    cta_sub: "Let's talk about how the digital operator can boost your area or brand.",
    legal_chip_versions: "Versions", legal_chip_snapshots: "Snapshots", legal_chip_hash: "SHA-256 Hash", legal_chip_history: "History",
    cta_btn: "Contact us",
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("nc_lang") || "es");
  const change = (l) => { setLang(l); localStorage.setItem("nc_lang", l); };
  const t = (key) => DICT[lang]?.[key] || DICT.es[key] || key;
  const tr = (field) => {
    if (!field) return "";
    if (typeof field === "string") return field;
    return field[lang] || field.es || "";
  };
  return <LangContext.Provider value={{ lang, setLang: change, t, tr }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
